/** Input primitive. */
import * as React from 'react';
import { cn } from '@/lib/utils';

/** Props for {@link Input}. */
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

/** Unlabeled text input primitive. */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'modern-input-base modern-input-default',
          'file:border-0 file:bg-transparent file:text-base file:font-medium',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
